import React, { useEffect, useState } from "react";

import { GreeterEvent } from "@greeter/core";
import { RoundedButton, ProductCard, PageContainer } from "@greeter/matter";
import { IonPage, IonContent, IonIcon, useIonRouter } from "@ionic/react";
import { GreeterEventCard } from "@greeter-venue/components/GreeterEventCard";
import { SkeletonRect } from "@greeter-venue/components/SkeletonRect";
import { Slip } from "@greeter-venue/components/Slip";
import { SlipContent } from "@greeter-venue/components/SlipContent";
import { WhiteRoundedButton } from "@greeter-venue/components/WhiteRoundedButton";
import { arrowBack } from "ionicons/icons";
import { Link, useHistory } from "react-router-dom";
import { Routes } from "@greeter-venue/utility/Routes";
import { classNames, Loadable } from "@greeter-venue/utility";

import css from "./EventEditCompletedPage.module.scss";

export type EventEditCompletedPageProps = React.PropsWithChildren & {
  greeterEvent: Loadable<GreeterEvent>;
};

const FloatingBackButton: React.FC = () => {
  const history = useHistory();

  return (
    <div onClick={() => history.goBack()}>
      <IonIcon icon={arrowBack} />
    </div>
  );
};

export const EventEditCompletedPage: React.FC<EventEditCompletedPageProps> = ({
  greeterEvent,
}) => {
  const history = useHistory();

  return (
    <IonPage>
      <IonContent>
        <PageContainer>
          <Slip {...classNames(css.Slip)}>
            <SlipContent>
              <h1 style={{ fontWeight: "bold" }}>Sådan! Eventet er oprettet</h1>
              {greeterEvent === "loading" ? (
                <SkeletonRect width="14rem" height="10rem" />
              ) : (
                <GreeterEventCard {...greeterEvent} />
              )}
              <WhiteRoundedButton
                onClick={() => history.push(Routes.mainGroup.editEvent.route())}
              >
                Opret endnu et event
              </WhiteRoundedButton>
              <Link
                to={Routes.mainGroup.venueTab.root.route()}
                {...classNames(css.FinishButton)}
              >
                Afslut
              </Link>
              <div style={{ fontSize: "0.8rem" }}>
                Brugerne kan nu finde og se dit event 🥳
              </div>
            </SlipContent>
          </Slip>
        </PageContainer>
      </IonContent>
    </IonPage>
  );
};
